module.exports = __webpack_public_path__ + "static/logo+transparent-5f10ac74e4d7428a65a6e1a8189f4379.jpg";